import React from 'react';
import styled from 'styled-components';
import { IFilterLogicOp } from '../../types';
import KubitTooltip from '../../../KubitTooltip';
import { LogicalOperatorKey } from '../../../../utils/apollo/graphqlSchema';
import { useFilterWidgetPropContext } from '../../FilterWidgetPropContext';
import { theme } from '../../../../styles/theme';
import { ConnectorWrapper } from '../../../Builder/BuilderUI';

interface IProps {
  type: 'condition' | 'predicate';
  operator: IFilterLogicOp;
  onChange: (logicOp: IFilterLogicOp) => void;
}

const StyledCondition = styled(ConnectorWrapper)`
  text-transform: uppercase;
  &:hover {
    cursor: pointer;
  }
`;
const StyledPredicate = styled.button`
  display: inline-block;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  text-align: center;
  line-height: 1.5;
  color: ${theme.colors.secondary800};
  &:not(:disabled):hover {
    cursor: pointer;
    color: ${theme.colors.mainBlue};
  }
`;

const FilterWidgetLogicOp = ({ type, operator, onChange }: IProps) => {
  const { defaultLogOps } = useFilterWidgetPropContext();

  const oppositeOperatorKey =
    operator.key === LogicalOperatorKey.And
      ? LogicalOperatorKey.Or
      : LogicalOperatorKey.And;

  const handleClick = () => {
    const newValue = defaultLogOps.find(
      (logOp) => logOp.key === oppositeOperatorKey,
    );

    if (newValue) {
      onChange(newValue);
    }
  };

  const tooltipContent = `Switch to ${oppositeOperatorKey}`;

  return (
    <KubitTooltip
      content={tooltipContent}
      placement="bottom"
      noOpenDelay={true}
    >
      {type === 'condition' ? (
        <StyledCondition as="button" type="button" onClick={handleClick}>
          {operator.name}
        </StyledCondition>
      ) : (
        <StyledPredicate type="button" onClick={handleClick}>
          {operator.name}
        </StyledPredicate>
      )}
    </KubitTooltip>
  );
};

export default FilterWidgetLogicOp;
